module.exports = __webpack_public_path__ + "circle-screenshot.png";